module.exports = "<div id=\"container\">\n\n  <topnavbar></topnavbar>\n\n\n  <imagebanner></imagebanner>\n  <div class=\"wrapper\">\n    <navigation></navigation>\n\n    <div id=\"content\">\n      <div id=\"home\">\n        <div class=\"servizi_home\">\n          <router-outlet>\n          </router-outlet>\n          <div style=\"clear:both\"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/layouts/basic/basic.component.html
// module id = ./src/app/common/layouts/basic/basic.component.html
// module chunks = main